module.exports = __webpack_public_path__ + "img/tick_green.4e4f22d5.png";